import { useMutation } from '@tanstack/react-query';
import { getFiscData } from '../api/service.api';

export const useGetFiscData = () => {
    return useMutation({
        mutationFn: (vmId: number) => getFiscData(vmId),
    });
};
